import { ReactNode } from 'react'

import { AstraSkeletonLoader } from '~/astra'

type Props = {
    isLoading: boolean
    children: ReactNode
}

export const InformationRow = ({ isLoading, children }: Props) =>
    isLoading ? (
        <span className="h-6 w-full">
            <AstraSkeletonLoader />
        </span>
    ) : (
        <div className="flex justify-between">{children}</div>
    )
